import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

function shuffleArray(array) {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function buildMatchData(props) {
  const leftSide = [
    props.left_text_one,
    props.left_text_two,
    props.left_text_three,
    props.left_text_four,
  ];

  const rightSide = [
    props.right_text_one,
    props.right_text_two,
    props.right_text_three,
    props.right_text_four,
  ];

  const correctAnswers = {
    [props.left_text_one]: props.right_text_one,
    [props.left_text_two]: props.right_text_two,
    [props.left_text_three]: props.right_text_three,
    [props.left_text_four]: props.right_text_four,
  };

  return { leftSide, rightSide, correctAnswers };
}

export default class MatchSentences extends Component {
  constructor(props) {
    super(props);

    const { leftSide, rightSide, correctAnswers } = buildMatchData(props);

    this.correctAnswers = correctAnswers;

    this.state = {
      selectedLeft: null,
      lockedMatches: [],
      incorrectMatch: false,
      incorrectRight: null,
      rightOrder: shuffleArray(rightSide),
      leftSide,
    };

    this.handleLeftSelect = this.handleLeftSelect.bind(this);
    this.handleRightSelect = this.handleRightSelect.bind(this);
    this.isAlreadyMatched = this.isAlreadyMatched.bind(this);
  }

  handleLeftSelect(left) {
    this.setState({ selectedLeft: left });
  }

  handleRightSelect(right) {
    const { selectedLeft, lockedMatches, rightOrder } = this.state;
    const { correctAnswers, contentComplete, correctAnswerText, incorrectAnswerText } = this.props;

    if (selectedLeft && this.correctAnswers[selectedLeft] === right) {
      const newLocked = [...lockedMatches, { left: selectedLeft, right }];

      // Swap rightSide order visually
      const newOrder = [...rightOrder];
      const leftIndex = this.state.leftSide.indexOf(selectedLeft);
      const rightIndex = newOrder.indexOf(right);

      [newOrder[leftIndex], newOrder[rightIndex]] = [newOrder[rightIndex], newOrder[leftIndex]];

      this.setState({
        lockedMatches: newLocked,
        selectedLeft: null,
        incorrectMatch: false,
        incorrectRight: null,
        rightOrder: newOrder,
      }, () => {
        if (newLocked.length === this.state.leftSide.length) {
          contentComplete();
          toast.success(correctAnswerText, {
            position: 'top-center',
            transition: Zoom,
            autoClose: 2000,
            hideProgressBar: true,
          });
        }
      });
    } else {
      this.setState({
        incorrectMatch: true,
        incorrectRight: right,
      });

      setTimeout(() => {
        this.setState({
          incorrectMatch: false,
          incorrectRight: null,
          selectedLeft: null,
        });

        toast.error(incorrectAnswerText, {
          position: 'top-center',
          transition: Zoom,
          autoClose: 2000,
          hideProgressBar: true,
        });

        this.props.error(true);
      }, 1000);
    }
  }

  isAlreadyMatched(sentence) {
    return this.state.lockedMatches.some(match => match.left === sentence || match.right === sentence);
  }

  render() {
    const { question, leftSide, disableHeader, image, title } = this.props;
    const {
      selectedLeft,
      lockedMatches,
      incorrectMatch,
      incorrectRight,
      rightOrder,
    } = this.state;
    console.log('props', this.props);

    return (
      <div className="wrapper__matchSentences">
        {!disableHeader && (
          <div className="question__header">
            {title && <h1>{title}</h1>}
            {image && <img src={image} alt="Match question header" />}
          </div>
        )}
        <h4 className='question'>{question}</h4>
        <div className="match__container">
          <div className="leftSide">
            {this.state.leftSide.map((left) => (
              <button
                key={left}
                onClick={() => this.handleLeftSelect(left)}
                disabled={this.isAlreadyMatched(left)}
                className={
                  `match__button ${selectedLeft === left ? 'selected' : ''} ${this.isAlreadyMatched(left) ? 'matched' : ''} ${incorrectMatch && selectedLeft === left ? 'incorrect' : ''}`
                }
              >
                {left}
              </button>
            ))}
          </div>
          <div className="rightSide">
            {rightOrder.map((right) => (
              <button
                key={right}
                onClick={() => {
                  if (selectedLeft && !this.isAlreadyMatched(right)) {
                    this.handleRightSelect(right);
                  }
                }}
                disabled={this.isAlreadyMatched(right)}
                className={
                  `match__button 
                   ${!selectedLeft && !this.isAlreadyMatched(right) ? 'inactive' : ''}
                   ${this.isAlreadyMatched(right) ? 'matched' : ''} 
                   ${incorrectMatch && incorrectRight === right ? 'incorrect' : ''}`
                }
              >
                {right}
              </button>
            ))}
          </div>
        </div>
        <ToastContainer draggablePercent={70} />
        {this.props.error(false)}
      </div>
    );
  }
}

MatchSentences.propTypes = {
  leftSide: PropTypes.arrayOf(PropTypes.string).isRequired,
  rightSide: PropTypes.arrayOf(PropTypes.string).isRequired,
  correctAnswers: PropTypes.object.isRequired,
  contentComplete: PropTypes.func,
  correctAnswerText: PropTypes.string,
  incorrectAnswerText: PropTypes.string,
  disableHeader: PropTypes.bool,
  error: PropTypes.func,
  image: PropTypes.string,
  question: PropTypes.string,
  title: PropTypes.string,
};

MatchSentences.defaultProps = {
  contentComplete: () => { },
  correctAnswerText: 'Correct!',
  incorrectAnswerText: 'Try again',
  disableHeader: false,
  error: () => { },
  image: '',
  question: '',
  title: '',
};
